import type { VirtualAppointmentDto } from '../../services/virtualAppointments';
import {
    VA_CARD_LIST_CLASS,
    VirtualAppointmentAccordionItem
} from './VirtualAppointmentAccordionItem';
import {
    VirtualAppointmentDetailPrompt,
    VirtualAppointmentReadOnlyDescription
} from './VirtualAppointmentDetailPanels';
import { useExpandedKeys } from './useExpandedKeys';
import { summaryFromDto } from './virtualAppointmentSummary';

interface PlannedVirtualAppointmentListProps {
    planned: readonly VirtualAppointmentDto[];
    /** Resolves each week trigger to its due day; null when unknown. */
    treatmentStartDate: string | null;
}

// Read-only look ahead: folded cards that open onto the description; edits happen in RDI/SDI.
export function PlannedVirtualAppointmentList({
    planned,
    treatmentStartDate
}: PlannedVirtualAppointmentListProps) {
    const { isExpanded, toggle } = useExpandedKeys();

    if (planned.length === 0) {
        return <VirtualAppointmentDetailPrompt message="No planned VAs" />;
    }
    return (
        <div className={VA_CARD_LIST_CLASS}>
            {planned.map((va) => (
                <VirtualAppointmentAccordionItem
                    key={va.id}
                    summary={summaryFromDto(va, treatmentStartDate)}
                    expanded={isExpanded(va.id)}
                    onToggle={() => toggle(va.id)}
                    done={false}
                    team={va.team}
                >
                    <VirtualAppointmentReadOnlyDescription doc={va.descriptionDoc} layout="plain" />
                </VirtualAppointmentAccordionItem>
            ))}
        </div>
    );
}
